import React from 'react';
import BasicLayout from './layouts/BasicLayout';

function App() {
  return (
    <BasicLayout />
  );
}

export default App;
